import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import CustomInput from '../../../../../utils/redux-forms-custom-fields/CustomInput';
import CustomInputCheckbox from '../../../../../utils/redux-forms-custom-fields/CustomInputCheckbox';

const StepsGeneric = ({
  fields,
  meta: { error, submitFailed },
  kind,
  onStepSwap
}) => {
  const handleRemoveField = (index) => {
    if (window.confirm('Are you sure about removing this field?')) {
      fields.remove(index);
    }
  };

  const handleAddStep = () => {
    fields.push({
      description: null,
      isRequired: true,
      title: null,
      type: 'collect-user-information',
    });
  };

  return (
    <section className="Step">
      <ul>
        {fields.map((step, index) => (
          <li key={index}>
            <section className="Step__header">
              <button
                className="Step__item-remove"
                type="button"
                onClick={() => handleRemoveField(index)}
              >
                <i className="fa fa-trash" />
              </button>
            </section>
            
            <section className="Step__body">
              <section className="Step__fields">
                <div className="Step__row Step__row--2">
                  <Field
                    name={`${step}.title`}
                    id={`${step}.title`}
                    type="text"
                    component={CustomInput}
                    label="Title"
                    placeholder="Title" 
                    customLabel="Title"
                  />
                  <Field
                    name={`${step}.isRequired`}
                    id={`${step}.isRequired`}
                    type="checkbox"
                    placeholder="Is Required"
                    customLabel="Is Required"
                    component={CustomInputCheckbox}
                    value
                  />
                </div>

                <Field
                  type="text"
                  name={`${step}.description`}
                  id={`${step}.description`}
                  placeholder="Additional Information Description"
                  customLabel="Description"
                  component={CustomInput}
                />
              </section>

              <section className="Step__arrows">
                <div 
                  className="Step__arrow--up" 
                  style={{ display: (index !== 0) ? 'block' : 'none' }}
                  onClick={() => onStepSwap(kind, index, 'up')}
                  aria-hidden="true"
                >
                  <i className="fa fa-arrow-up" />
                </div>
                <div
                  className="Step__arrow--down"
                  style={{ display: (fields.length - 1 !== index) ? 'block' : 'none' }}
                  onClick={() => onStepSwap(kind, index, 'down')}
                  aria-hidden="true"
                >
                  <i className="fa fa-arrow-down" />
                </div>
              </section>
            </section>
          </li>
        ))}
      </ul>

      {(submitFailed && error) && (
        <span className="Step__error">{error}</span>
      )}

      <button
        className="Step__add-item"
        type="button"
        onClick={handleAddStep}
      >
        Add Additional Information
      </button>
    </section>
  );
};

StepsGeneric.propTypes = {
  fields: PropTypes.object.isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    submitFailed: PropTypes.bool
  }).isRequired,
  kind: PropTypes.string.isRequired,
  onStepSwap: PropTypes.func.isRequired
};

export default StepsGeneric;